import { MarketPlaceFilter } from "./MarketPlaceFilter";
import { ProductsContainerBox } from "./ProductsContainerBox";
import { UpperContentSubCategory } from "./UpperContentSubCategory";
import styles from './UpperContentSubCategory/UpperContentSubCategory.module.css';
import { IMarketingBanner, IMarketPlaceFilters, IMarketplaceFilterType, ISubCategoryData } from "@/interfaces";
import { useCallback, useEffect, useState } from "react";
import { API } from "@/lib/helpers/http-client";
import { useRouter } from "next/router";
import { Pagination } from "@/components/shared/pagination";
import { useGlobalContext } from "@/lib/context";
import { pushRoute } from "@/lib/helpers/common";

type props = {
    data: ISubCategoryData
    marketingBanner: IMarketingBanner[]
}
export function SubCategoryPage({ data, marketingBanner }: props) {
    const { props: { pageURL, setLoading } } = useGlobalContext();
    const [checkedAtrributes, setCheckAttributes] = useState<any>([]);
    const [isMobileFilterActive, setMobileFilterActive] = useState(false);
    const [products, setProducts] = useState(data.products || []);
    const [filters, setFilter] = useState(data.filters || []);
    const [productCount, setProductCount] = useState(data.productCount || 0);
    const [totalPages, setTotalPages] = useState(data.pagination.noOfPages);
    const [activeSort, setActiveSort] = useState('New');
    const router = useRouter();
    const [minPrice, setMinPrice] = useState(Number(router.query['min-price']) || data.minPrice);
    const [maxPrice, setMaxPrice] = useState(Number(router.query['max-price']) || data.maxPrice);

    const handleSort = async (sort: string) => {
        window.scrollTo(0, 0);
        delete router.query.page;
        window.history.pushState(null, '', pageURL);
        setActiveSort(sort);
        await fetchProducts(1, sort);
        localStorage.setItem('sortBy', sort);
    };
    const handleAttributes = async (
        e: any,
        attribute: { AttributeNameSlug: string; AttributeValueSlug: string }
    ) => {
        e?.preventDefault();
        const Query: any = router.query ? { ...router.query } : {};
        const currentQuery = Object.fromEntries(
            Object.entries(Query).filter(([key]) => key !== 'category' && key !== 'subCategory')
        );

        // Get currently selected filters from the URL
        const currentValues = currentQuery[attribute.AttributeNameSlug]
            ? (currentQuery[attribute.AttributeNameSlug] as string).split(',')
            : [];
        if(currentValues.length === 0){
            pushRoute(`${process.env.SITE_URL}/online-store/${data.serviceSlug}/${data.categorySlug}`);
        }        
        const valueIndex = currentValues.indexOf(attribute.AttributeValueSlug);

        // If we're removing a filter (value exists in current filters)
        if (valueIndex > -1) {
            // Remove the value from the array
            currentValues.splice(valueIndex, 1);

            // If this was the last value for this attribute, remove the attribute entirely
            if (currentValues.length === 0) {
                delete currentQuery[attribute.AttributeNameSlug];
            } else {
                currentQuery[attribute.AttributeNameSlug] = currentValues.join(',');
            }

            // Get the remaining selected filters after removal
            const remainingFilters = filters.reduce((acc: any[], filter) => {
                filter.attributeValues.forEach(attr => {
                    if (attr.isSelectedAttributeValue === 1 &&
                        !(attr.attributeValueSlug === attribute.AttributeValueSlug &&
                            filter.attributeNameSlug === attribute.AttributeNameSlug)) {
                        acc.push({
                            AttributeNameSlug: filter.attributeNameSlug,
                            AttributeValueSlug: attr.attributeValueSlug,
                            isGenerateFilterUrl: filter.isGenerateFilterUrl
                        });
                    }
                });
                return acc;
            }, []);
            // If exactly one filter with isGenerateFilterUrl remains
            if (remainingFilters.length === 1 && remainingFilters[0].isGenerateFilterUrl === 1) {
                const remainingFilter = remainingFilters[0];
                const filterConfig = filters.find(f => f.attributeNameSlug === remainingFilter.AttributeNameSlug);

                // Construct the filter URL
                let url = `${process.env.SITE_URL}/online-store/${remainingFilter.AttributeValueSlug}-online-${data.categorySlug}-${data.categoryIdentifier}-${filterConfig?.attributeId}`;

                // Add price parameters if they exist
                const priceParams = [];
                if (currentQuery['min-price']) {
                    priceParams.push(`min-price=${currentQuery['min-price']}`);
                }
                if (currentQuery['max-price']) {
                    priceParams.push(`max-price=${currentQuery['max-price']}`);
                }

                if (priceParams.length > 0) {
                    url += `?${priceParams.join('&')}`;
                }
                pushRoute(url);
            } else {

                // Otherwise, construct search URL with remaining parameters
                let url = `${process.env.SITE_URL}/online-store/${data.serviceSlug}/${data.categorySlug}/search`;
                const queryParams = [];

                // Handle remaining query parameters
                for (const [key, value] of Object.entries(currentQuery)) {
                    if (value && key !== 'page' && key !== 'subcategory') {
                        queryParams.push(`${key}=${encodeURIComponent(value as string)}`);
                    }
                }
                if (queryParams.length > 0) {
                    url += `?${queryParams.join('&')}`; // Changed from & to ? for first parameter
                } else {
                    url = `${process.env.SITE_URL}/online-store/${data.serviceSlug}/${data.categorySlug}`;
                }
                pushRoute(url);
            }

        }
    };
    const fetchProducts = useCallback(async (nextPage: number, sortType?: string) => {
        setLoading(true);
        const sortBy = sortType || localStorage.getItem('sortBy') || activeSort;
        let attributes;
        if (router.query['min-price'] && router.query['max-price']) {
            attributes = [...checkedAtrributes,
            { "AttributeNameSlug": "min-price", "AttributeValueSlug": router.query['min-price'] },
            { "AttributeNameSlug": "max-price", "AttributeValueSlug": router.query['max-price'] }
            ]
        } else {
            attributes = checkedAtrributes
        }
        try {
            const body = {
                "CityName": "Delhi",
                "SearchSlug": data.categorySlug,
                "LstAttr": attributes,
                "PageSize": 16,
                "SortBy": sortBy,
                "PageNo": nextPage
            }
            const result: any = await API.post(`/api/getmktproducts`, body);
            if (result && result.status == 200 && result.data.products) {
                setTotalPages(result.data.pagination.noOfPages);
                setFilter(result.data.filters);
                setProductCount(result.data.productCount);
                if (sortType) {
                    setProducts(result.data.products);
                } else {
                    setProducts(a => [...a, ...result.data.products]);
                }
            }
        } catch (error: any) {
            console.error(error.message);
        }
        setLoading(false);
    }, [activeSort, checkedAtrributes]);

    useEffect(() => {
        const selectedFilters: any[] = [];
        filters.forEach(filter => {
            filter.attributeValues.forEach(attr => {
                if (attr.isSelectedAttributeValue === 1) {
                    selectedFilters.push({
                        AttributeNameSlug: filter.attributeNameSlug,
                        AttributeValueSlug: attr.attributeValueSlug
                    });
                }
            });
        });
        setCheckAttributes(selectedFilters);
        const filterAttr: any = localStorage.getItem(`${data.categorySlug}-filterattr`) || '';
        if (filterAttr != '') {
            handleAttributes('', JSON.parse(filterAttr))
            localStorage.removeItem(`${data.categorySlug}-filterattr`)
        }
        localStorage.removeItem('sortBy');
    }, []);

    const processFilters = (filters: IMarketPlaceFilters[], subCategorySlug: string, categoryIdentifier: string, categorySlug: string): IMarketPlaceFilters[] => {
        const selectedFilters: IMarketplaceFilterType[] | any = [];
        const isSearchPage = pageURL.includes('search');
        const baseSlug = `${categorySlug}/${subCategorySlug}`
        const generateSearchUrl = (filterGroups: { [key: string]: string[] }, excludeValue?: { key: string; value: string }): string => {
            // Start with the base URL
            let url = `${process.env.SITE_URL}/online-store/${baseSlug}/search`;
            // Initialize with '?' for the first parameter
            let hasParams = false;
            // Add price filters from router query
            if (router.query['min-price']) {
                url += `${hasParams ? '&' : '?'}min-price=${router.query['min-price']}`;
                hasParams = true;
            }
            if (router.query['max-price']) {
                url += `${hasParams ? '&' : '?'}max-price=${router.query['max-price']}`;
                hasParams = true;
            }

            // Add other filter groups
            Object.entries(filterGroups).forEach(([key, values]) => {
                if (excludeValue && key === excludeValue.key) {
                    const filteredValues = values.filter(v => v !== excludeValue.value);
                    if (filteredValues.length > 0) {
                        url += `${hasParams ? '&' : '?'}${key}=${filteredValues.join('%2C')}`;
                        hasParams = true;
                    }
                } else if (values.length > 0) {
                    url += `${hasParams ? '&' : '?'}${key}=${values.join('%2C')}`;
                    hasParams = true;
                }
            });
            return url;
        };

        // Get selected filters (excluding price filters)
        filters.forEach(filter => {
            filter.attributeValues.forEach(attr => {
                if (attr.isSelectedAttributeValue === 1) {
                    selectedFilters.push({
                        ...attr,
                        attributeNameSlug: filter.attributeNameSlug,
                        isGenerateFilterUrl: filter.isGenerateFilterUrl
                    });
                }
            });
        });
        // Process and return filters (excluding price filters)
        return filters?.filter((f) => !f.attributeName.includes('Price')).map((filter: IMarketPlaceFilters) => {
            const processedValues = filter.attributeValues.map((attr: IMarketplaceFilterType) => {
                // Build current filter groups state
                const filterGroups: { [key: string]: string[] } = {};
                selectedFilters.forEach((selected: any) => {
                    const filterGroup = filters.find(f =>
                        f.attributeValues.some(av => av.attributeValueSlug === selected.attributeValueSlug)
                    );
                    if (filterGroup) {
                        if (!filterGroups[filterGroup.attributeNameSlug]) {
                            filterGroups[filterGroup.attributeNameSlug] = [];
                        }
                        filterGroups[filterGroup.attributeNameSlug].push(selected.attributeValueSlug);
                    }
                });

                const isOnlySelectedInGroup = selectedFilters.length === 1 &&
                    selectedFilters[0].attributeValueSlug === attr.attributeValueSlug;

                // Case 1: When removing a filter and only one filter with isGenerateFilterUrl will remain
                if (attr.isSelectedAttributeValue === 1 && selectedFilters.length === 2) {
                    const otherFilter = selectedFilters.find((f: any) => f.attributeValueSlug !== attr.attributeValueSlug);
                    if (otherFilter && filter.isGenerateFilterUrl === 1 &&
                        filters.find(f => f.attributeNameSlug === otherFilter.attributeNameSlug)?.isGenerateFilterUrl === 1) {
                        const baseUrl = `${process.env.SITE_URL}/online-store/${otherFilter.attributeValueSlug}-online-${subCategorySlug}-${categoryIdentifier}-${filters.find(f => f.attributeNameSlug === otherFilter.attributeNameSlug)?.attributeId}`;

                        // Add price parameters if they exist
                        let priceString = '';
                        if (router.query['min-price'] || router.query['max-price']) {
                            priceString = '?';
                            if (router.query['min-price']) {
                                priceString += `min-price=${router.query['min-price']}`;
                            }
                            if (router.query['max-price']) {
                                priceString += `${priceString.length > 1 ? '&' : ''}max-price=${router.query['max-price']}`;
                            }
                        }

                        return {
                            ...attr,
                            url: priceString ? `${baseUrl}${priceString}` : baseUrl
                        };
                    }
                }

                // Handle other cases using the updated generateSearchUrl function
                if (attr.isSelectedAttributeValue === 1 && isOnlySelectedInGroup && !router.query['min-price'] && !router.query['max-price']) {
                    return {
                        ...attr,
                        url: `${process.env.SITE_URL}/online-store/${categorySlug}/${subCategorySlug}`
                    };
                }

                if (attr.isSelectedAttributeValue === 1 && selectedFilters.length > 1) {

                    if (selectedFilters.length === 2 && filter.isGenerateFilterUrl === 0) {
                        const otherFilter = selectedFilters.find((f: any) => f.attributeValueSlug !== attr.attributeValueSlug);
                        const baseUrl = `${process.env.SITE_URL}/online-store/${otherFilter.attributeValueSlug}-online-${subCategorySlug}-${categoryIdentifier}-${filters.find(f => f.attributeNameSlug === otherFilter.attributeNameSlug)?.attributeId}`;
                        return {
                            ...attr,
                            url: baseUrl
                        }
                    }
                    const updatedFilterGroups = { ...filterGroups };
                    if (updatedFilterGroups[filter.attributeNameSlug]) {
                        updatedFilterGroups[filter.attributeNameSlug] = updatedFilterGroups[filter.attributeNameSlug]
                            .filter(value => value !== attr.attributeValueSlug);

                        if (updatedFilterGroups[filter.attributeNameSlug].length === 0) {
                            delete updatedFilterGroups[filter.attributeNameSlug];
                        }
                    }

                    return {
                        ...attr,
                        url: generateSearchUrl(updatedFilterGroups)
                    };
                }

                if (filter.isGenerateFilterUrl === 1) {
                    if (selectedFilters.length > 0 || isSearchPage) {
                        const updatedFilterGroups = { ...filterGroups };
                        if (!updatedFilterGroups[filter.attributeNameSlug]) {
                            updatedFilterGroups[filter.attributeNameSlug] = [];
                        }
                        updatedFilterGroups[filter.attributeNameSlug] = [
                            ...updatedFilterGroups[filter.attributeNameSlug],
                            attr.attributeValueSlug
                        ];

                        return {
                            ...attr,
                            url: generateSearchUrl(updatedFilterGroups)
                        };
                    }

                    const baseUrl = `${process.env.SITE_URL}/online-store/${attr.attributeValueSlug}-online-${subCategorySlug}-${categoryIdentifier}-${filter.attributeId}`;

                    // Add price parameters if they exist
                    let priceString = '';
                    if (router.query['min-price'] || router.query['max-price']) {
                        priceString = '?';
                        if (router.query['min-price']) {
                            priceString += `min-price=${router.query['min-price']}`;
                        }
                        if (router.query['max-price']) {
                            priceString += `${priceString.length > 1 ? '&' : ''}max-price=${router.query['max-price']}`;
                        }
                    }

                    return {
                        ...attr,
                        url: priceString ? `${baseUrl}${priceString}` : baseUrl
                    };
                }

                return {
                    ...attr,
                    url: generateSearchUrl({
                        ...filterGroups,
                        [filter.attributeNameSlug]: [
                            ...(filterGroups[filter.attributeNameSlug] || []),
                            attr.attributeValueSlug
                        ]
                    })
                };
            });

            return {
                ...filter,
                attributeValues: processedValues
            };
        });
    };
    data.filters = processFilters(filters, data.categorySlug, data.categoryIdentifier, data.serviceSlug);

    return (<>
        <UpperContentSubCategory data={data} checkedAtrributes={checkedAtrributes} handleAttributes={handleAttributes} handleSort={handleSort} activeSort={activeSort} productCount={productCount} priceFilter={{ prevMinPrice: data.minPrice, prevMaxPrice: data.maxPrice, minPrice, maxPrice }} />
        <div className={styles.categorySectnBx}>
            <div className={styles.sectionFlex}>
                <div className={styles.sectionFlex}>
                    <MarketPlaceFilter data={data} filters={data.filters} checkedAtrributes={checkedAtrributes} handleAttributes={handleAttributes} isMobileFilterActive={isMobileFilterActive} setMobileFilterActive={setMobileFilterActive} fetchProducts={fetchProducts} handleSort={handleSort} minPrice={minPrice} maxPrice={maxPrice} setMinPrice={setMinPrice} setMaxPrice={setMaxPrice} />
                    <ProductsContainerBox products={products} marketingBanner={marketingBanner} />
                </div>
            </div>
            <div style={{ paddingTop: '10px' }}>
                <Pagination key={totalPages + activeSort + checkedAtrributes.length} TotalPageCount={totalPages} fetchMoreData={fetchProducts} />
            </div>
        </div>
    </>);
}